module.exports = __webpack_public_path__ + "img/15.ca8c3f27.png";